import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Card } from "react-bootstrap";

import Chart from "../../utils/chart";

function PieReport({
  title = "Batch Processing Share",
  chartOptions = {},
  chartData,
  completed,
  pending,
  failed,
}) {
  const canvasRef = useRef();

  useEffect(() => {
    const chtdata = { ...chartData };
    chtdata.datasets[0].data = [completed, pending, failed];
    configureChart(chtdata);
  });

  function configureChart(chart_data) {
    const chartConfig = {
      type: "pie",
      data: chart_data,
      options: {
        ...{
          legend: {
            position: "bottom",
            labels: {
              padding: 25,
              boxWidth: 20,
            },
          },
          cutoutPercentage: 0,
          tooltips: {
            custom: false,
            mode: "index",
            position: "nearest",
          },
        },
        ...chartOptions,
      },
    };
    new Chart(canvasRef.current, chartConfig);
  }

  return (
    <Card className="h-100">
      <Card.Header className="border-bottom">
        <h6 className="m-0">{title}</h6>
      </Card.Header>
      <Card.Body className="d-flex py-0">
        <canvas
          height="220"
          ref={canvasRef}
          className="blog-users-by-device m-auto"
        />
      </Card.Body>
    </Card>
  );
}

PieReport.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string,
  /**
   * The chart config object.
   */
  chartConfig: PropTypes.object,
  /**
   * The Chart.js options.
   */
  chartOptions: PropTypes.object,
  /**
   * The chart data.
   */
  chartData: PropTypes.object,
};

PieReport.defaultProps = {
  title: "Current Month",
  chartData: {
    datasets: [
      {
        hoverBorderColor: "#ffffff",
        data: [0, 0, 0],
        backgroundColor: [
          "rgba(0,123,255,0.9)",
          "rgba(0,123,255,0.5)",
          "rgba(0,123,255,0.3)",
        ],
      },
    ],
    labels: ["Completed", "Pending", "Failed"],
  },
};

export default PieReport;
